module.exports = __webpack_public_path__ + "static/media/banking.fbbdd4bc.svg";